import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_API_SETTINGS',
    icon: 'GridIcon',
    route: 'apisettings',
    action: constants.action.permissionLogin,
    resource: constants.resource.user,
  },
]
